const types = {
  SHOW: 'schooladmin/flashMessages/SHOW',
  HIDE: 'schooladmin/flashMessages/HIDE',
  HIDE_ALL: 'schooladmin/flashMessages/HIDE_ALL'
};

const initialState = {
  stack: []
};

const flashMessages = (state = initialState, { type, props }) => {
  const { stack } = state;
  switch (type) {
    case types.SHOW:
      return { stack: [{ ...props }, ...stack] };

    case types.HIDE:
      const [_, ...newStack] = stack;

      return { stack: newStack };

    case types.HIDE_ALL:
      return { stack: [] };

    default:
      return state;
  }
};

function hide() {
  return { type: types.HIDE };
}

function hideAll() {
  return { type: types.HIDE_ALL };
}

function show(props = {}) {
  return (dispatch) => {
    dispatch({ type: types.SHOW, props });

    setTimeout(() => {
      dispatch(hide());
    }, 5000);
  };
}

export default {
  name: 'flashMessages',
  reducer: flashMessages,
  actions: {
    ...types,
    show,
    hide,
    hideAll
  }
};
